import type { InteractModuleListItem } from "@skilitics/nautilus-endpoint-definition";

import { getModulePathDescriptor } from "../shared.ts";

export const createFolderFilter = (filter: string) => (modules: InteractModuleListItem[]) =>
  modules.filter((module) => {
    const { path } = getModulePathDescriptor(module);

    return path.startsWith(filter);
  });
